import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M13.707 13.6H2.293a.7.7 0 0 1-.596-1.053l5.707-9.803a.688.688 0 0 1 1.192 0l5.707 9.803a.7.7 0 0 1-.596 1.053M8.64 5.694H7.36l.213 4.612h.854zm-.16 5.6h-.96v.988h.96z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }